import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  SimpleGrid,
  Heading,
  Text,
  Card,
  CardBody,
  CardHeader,
  Container,
  useColorModeValue,
  HStack,
  Button,
} from '@chakra-ui/react';

const API_URL = process.env.REACT_APP_API_URL;

const scripts = [
  { id: 1, title: 'Importar Archivos', description: 'Import and process data files' },
  // { id: 2, title: 'Filtro Edad', description: 'Filter data by age' },
  { id: 3, title: 'Normalización de Variables', description: 'Normalize variables in the dataset' },
  { id: 4, title: 'Eliminar registros y mover columnas', description: 'Remove records and rearrange columns' },
  { id: 5, title: 'Capitalizar nombre/apellido y separar apellidos', description: 'Capitalize names and split last names' },
  { id: 6, title: 'Exclusión de nombres con 3 letras con excepciones', description: 'Exclude 3-letter names with exceptions' },
  { id: 7, title: 'Límite de registros por valores', description: 'Limit records by values' },
  { id: '7.2', title: 'Selección de volumen específico por CP (sin filtros)', description: 'Select specific volume by postal code' },
  { id: '7.3', title: 'Selección de volumen específico por CP y edad (sin filtros)', description: 'Select specific volume by postal code and age' },
  { id: '7.4', title: 'Selección de volumen específico por CP principal y secundarios', description: 'Select specific volume by primary and secondary postal codes' },
  { id: 8, title: 'Creación de variables dicotómicas', description: 'Create dichotomous variables' },
  { id: 9, title: 'Eliminar columna', description: 'Remove columns from dataset' },
  { id: 10, title: 'Exportar los resultados', description: 'Export processed results' },
  { id: 11, title: 'Deduplicar con base del cliente', description: 'Deduplicate based on client database' },
  { id: 13, title: 'Dividir dataframe en ficheros más reducidos', description: 'Split dataframe into smaller files' },
  { id: 14, title: 'Conteos por grupos', description: 'Count by groups' },
  { id: 15, title: 'Concatenar archivos', description: 'Concatenate files' },
  { id: 16, title: 'Script de Nominatim para direcciones', description: 'Nominatim script for addresses' },
  { id: 17, title: 'Clasificador/ponderador por los 7 clusters', description: 'Classifier/weighting by 7 clusters based on focus group qualitatives and CAI/CAP decision trees' },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const cardBg = useColorModeValue('white', 'gray.700');
  const cardBorder = useColorModeValue('gray.200', 'gray.600');
  const [currentScriptName, setCurrentScriptName] = useState('');

  useEffect(() => {
    // Get the current script name from localStorage
    const storedName = localStorage.getItem('currentScriptName');
    if (storedName) {
      setCurrentScriptName(storedName);
    }
  }, []);

  const handleCardClick = (scriptId) => {
    navigate(`/script/${scriptId}`);
  };

  const handleViewChanges = () => {
    navigate('/changes');
  };

  const handleViewData = () => {
    navigate('/data');
  };

  const handleLogout = () => {
    // Clear all localStorage items
    localStorage.clear();
    // Force a page refresh
    window.location.href = '/';
  };

  return (
    <Container maxW="container.xl" py={8}>
      <HStack justify="space-between" align="center" mb={6}>
        <Box>
          <Heading>Scripts Dashboard</Heading>
          {currentScriptName && (
            <Text mt={2} fontSize="md" color="gray.600">
              Current File: {currentScriptName}
            </Text>
          )}
        </Box>
        <HStack spacing={4}>
          {currentScriptName && (
            <>
              <Button onClick={handleViewChanges} colorScheme="blue" variant="outline">
                Cambios
              </Button>
              <Button onClick={handleViewData} colorScheme="blue" variant="outline">
                Data
              </Button>
            </>
          )}
          <Button onClick={handleLogout} colorScheme="red" variant="outline">
            Logout
          </Button>
        </HStack>
      </HStack>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {scripts.map((script) => (
          <Card 
            key={script.id} 
            bg={cardBg}
            borderWidth="1px"
            borderColor={cardBorder}
            borderRadius="lg"
            overflow="hidden"
            _hover={{ transform: 'translateY(-2px)', shadow: 'lg' }}
            transition="all 0.2s"
            cursor="pointer"
            onClick={() => handleCardClick(script.id)}
          >
            <CardHeader>
              <Heading size="md">{script.title}</Heading>
            </CardHeader>
            <CardBody>
              <Text color="gray.600">{script.description}</Text>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
};

export default Dashboard; 